import { Form, Row, Col, Button, InputGroup } from "react-bootstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import Flatpickr from "react-flatpickr";
import {
  setActiveTab,
  setPaginationPageNumber,
  TriggerFilterButtonApi,
} from "../../../slices/common/reducer";
import {
  filterDateOptions,
  handleFilterDateChange,
} from "../../../Utils/CommonUtils";
import { AG_FROM_DATE, AG_TO_DATE } from "../../../Utils/FilterDateKeys";
import { setAgFilterForm } from "../../../slices/ag/affinityGroup/affinityGroupSlice";
import { CiSearch } from "react-icons/ci";
import "./AffinityGroup.scss";
import { getCategoryDropdown } from "../../../Utils/CommonService";
import { useEffect } from "react";

const AffinityGroupFilter = () => {
  const dispatch = useDispatch();

  const filterForm = useSelector((state) => state.affinityGroup.filter.form);
  const agCategory = useSelector((state) => state.common.categoryDropdown);

  const agDropDown = agCategory.map((ag) => {
    return {
      value: ag,
      label: ag,
    };
  });

  const resetTabAndPageNumber = () => {
    dispatch(setPaginationPageNumber(0));
    dispatch(setActiveTab("ALL"));
  };

  const handleInputChange = (name, value) => {
    dispatch(setAgFilterForm({ name, value }));
    resetTabAndPageNumber();
    dispatch(TriggerFilterButtonApi());
  };

  const agOptions = [
    { value: "ACTIVE", label: "Active" },
    { value: "INACTIVE", label: "Inactive" },
  ];

  const handleClear = () => {
    dispatch(setAgFilterForm({ type: "reset" }));

    dispatch(TriggerFilterButtonApi());

    if (Object.keys(filterForm).length > 0) {
      resetTabAndPageNumber();
    }
  };

  const isClearButtonDisabled = !Object.values(filterForm).some(
    (value) => value
  );

  useEffect(() => {
    getCategoryDropdown("AGRP", "ag_category");
  }, []);

  return (
    <div className="filter-wrapper">
      <Form className="form-input">
        <Row>
          <Form.Group as={Col} className="col-md-4">
            <InputGroup>
              <InputGroup.Text id="basic-addon1">
                {" "}
                <CiSearch />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search for Code, Name..."
                name="filter_ref"
                id="name"
                className="ag-searchbar"
                value={filterForm.filter_ref || ""}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                } // Update on change
              />
            </InputGroup>
          </Form.Group>
          <Form.Group as={Col} className="col-md-4">
            <Select
              isClearable
              placeholder="AG Category"
              name="buss_category"
              options={agDropDown}
              value={
                agDropDown.find(
                  (itm) => itm.value === filterForm.buss_category
                ) || null
              }
              onChange={(e) =>
                handleInputChange("buss_category", e ? e.value : "")
              }
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-3">
            <Select
              isClearable
              placeholder="Status"
              name="status"
              options={agOptions}
              value={
                agOptions.find((itm) => itm.value === filterForm.status) || null
              }
              onChange={(e) => handleInputChange("status", e ? e.value : "")}
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-1">
            <div>
              <Button
                className="primary-outline"
                onClick={handleClear}
                disabled={isClearButtonDisabled}
              >
                Clear
              </Button>
            </div>
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
};

export default AffinityGroupFilter;
